module.exports = __webpack_public_path__ + "media/mypage/images/icons/icon_dashbord-73c545a39c2eb80a1f5e2d5888f89845.png";